import { render, staticRenderFns } from "./checkout-timer.vue?vue&type=template&id=904c8cae&scoped=true"
import script from "./checkout-timer.vue?vue&type=script&lang=js"
export * from "./checkout-timer.vue?vue&type=script&lang=js"
import style0 from "./checkout-timer.vue?vue&type=style&index=0&id=904c8cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904c8cae",
  null
  
)

export default component.exports